import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import AdminPage from './components/admin/AdminPage';
import LoginPage from './components/admin/LoginPage';
import MetricsPage from './components/metrics/MetricsPage';
import ProtectedRoute from './components/common/ProtectedRoute';

function App() {

  return (
    <Router basename="/metrics">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path=":id?" element={<MetricsPage />} />
          <Route path="admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
          <Route path="login" element={<LoginPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
